import { render, staticRenderFns } from "./FaenaCosecha.vue?vue&type=template&id=71a6afea&scoped=true"
import script from "./FaenaCosecha.vue?vue&type=script&lang=js"
export * from "./FaenaCosecha.vue?vue&type=script&lang=js"
import style0 from "./FaenaCosecha.vue?vue&type=style&index=0&id=71a6afea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6afea",
  null
  
)

export default component.exports